/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-shadow */
import { Action, createAction, props } from '@ngrx/store';

export enum LogsActionTypes {
  AddLog = '[Logs] Add log',
  AddInfoLog = '[Logs] Add info log',
  AddErrorLog = '[Logs] Add error log',
  AddWarningLog = '[Logs] Add warning log',
  AddCriticalLog = '[Logs] Add critial log',
  SendLogsRequested = '[Logs] Send log requested',
  SendLogsSuccess = '[Logs] Send log success',
  SendLogsFailed = '[Logs] Send log failed',
  SendNOLogs = '[Logs] Send NO Logs',
}

export enum LogTypes {
  info = 'info',
  warning = 'warning',
  error = 'error',
  critical = 'critical',
}

export const AddLog = createAction(LogsActionTypes.AddLog, props<{ typeLog: LogTypes; message: string; locationGuid?: string }>());
export const AddInfoLog = createAction(LogsActionTypes.AddInfoLog, props<{ message: string }>());
export const AddErrorLog = createAction(LogsActionTypes.AddErrorLog, props<{ message: string }>());
export const AddWarningLog = createAction(LogsActionTypes.AddWarningLog, props<{ message: string }>());
export const AddCriticalLog = createAction(LogsActionTypes.AddCriticalLog, props<{ message: string }>());
export const SendLogsRequested = createAction(LogsActionTypes.SendLogsRequested);
export const SendLogsSuccess = createAction(LogsActionTypes.SendLogsSuccess);
export const SendLogsFailed = createAction(LogsActionTypes.SendLogsFailed);
export const SendNOLogs = createAction(LogsActionTypes.SendNOLogs);
